export const racoaptereto = [
  {
    key: 'rol',
    letter: 'R',
    title: 'Rol',
    description: 'Define quién está asumiendo el papel en la interacción.',
    example: 'Eres un especialista en marketing digital'
  },
  {
    key: 'accion',
    letter: 'A',
    title: 'Acción',
    description: 'Especifica qué proceso debe llevar a cabo el rol definido.',
    example: 'Crea una estrategia de contenido'
  },
  {
    key: 'contexto',
    letter: 'C',
    title: 'Contexto',
    description: 'Proporciona información adicional sobre la situación o tema.',
    example: 'Para una nueva marca de ropa sostenible que busca aumentar su visibilidad'
  },
  {
    key: 'objetivo',
    letter: 'O',
    title: 'Objetivo',
    description: 'Establece el propósito de la acción.',
    example: 'Aumentar el número de seguidores y generar interacción con los usuarios'
  },
  {
    key: 'audiencia',
    letter: 'A',
    title: 'Audiencia',
    description: 'Describe a quién(es) se dirige el contenido.',
    example: 'El contenido está dirigido a personas de la Generación Z, nacidas entre 1997 y 2012'
  },
  {
    key: 'plataforma',
    letter: 'P',
    title: 'Plataforma',
    description: 'Especifica el medio o canal de publicación.',
    example: 'Para publicar en la red social de Instagram'
  },
  {
    key: 'tarea',
    letter: 'T',
    title: 'Tarea',
    description: 'Describe la actividad específica a realizar.',
    example: 'Desarrolla un calendario de publicaciones para el próximo mes'
  },
  {
    key: 'ejemplo',
    letter: 'E',
    title: 'Ejemplo',
    description: 'Proporciona una ilustración concreta de la acción.',
    example: 'Publica una entrada sobre "10 maneras de vestir sostenible" cada lunes'
  },
  {
    key: 'resultado',
    letter: 'R',
    title: 'Resultado',
    description: 'Indica el efecto final esperado.',
    example: 'Al final del mes, deberías tener al menos 200 nuevos seguidores y un 10% de tasa de interacción'
  },
  {
    key: 'estilo',
    letter: 'E',
    title: 'Estilo',
    description: 'Define el carácter/lenguaje de comunicación.',
    example: 'Utiliza un estilo visual atractivo y moderno, acorde con la estética de Instagram'
  },
  {
    key: 'tono',
    letter: 'T',
    title: 'Tono',
    description: 'Establece el matiz emocional o actitudinal.',
    example: 'Mantén un tono amigable y motivador, invitando a los usuarios a participar'
  },
  {
    key: 'opciones',
    letter: 'O',
    title: 'Opciones',
    description: 'Ofrece alternativas creativas o variaciones en el abordaje.',
    example: 'Puedes incluir historias interactivas, encuestas o colaboraciones con influenciadores para aumentar el alcance'
  }
];

export const examplePrompt = `Eres un especialista en marketing digital que debe crear una estrategia de contenido, proporcionando información adicional para una nueva marca de ropa sostenible que busca aumentar su visibilidad. El propósito de esta acción es aumentar el número de seguidores y generar interacción con los usuarios. El contenido está dirigido a personas de la Generación Z, nacidas entre 1997 y 2012. Se publicará en la red social de Instagram. Debes desarrollar un calendario de publicaciones para el próximo mes, publicando una entrada sobre "10 maneras de vestir sostenible" cada lunes. Al final del mes, deberías tener al menos 200 nuevos seguidores y un 10% de tasa de interacción. Utiliza un estilo visual atractivo y moderno, acorde con la estética de Instagram, manteniendo un tono amigable y motivador que invite a los usuarios a participar. Puedes incluir historias interactivas, encuestas o colaboraciones con influenciadores para aumentar el alcance.`;